import { Navigate, useLocation } from "react-router-dom";

import { GlobalUtils } from "../utils/globalUtils";

interface PublicRouteProps {
  element: JSX.Element;
}

export const PublicRoute = ({ element }: PublicRouteProps) => {
  const token = localStorage.getItem("authToken");
  const location = useLocation();

  const from =
    location.state?.from || GlobalUtils.getUserRole() === "ADMIN"
      ? "/admin"
      : "/profile";
  // fallback to dashboard

  if (token) {
    return <Navigate to={from} replace />;
  }

  return element;
};
